<table class="table table-responsive align-middle" [attr.id]="'' + refid" [ngClass]="custom">
  <thead>
    <tr>
      <ng-content *ngTemplateOutlet="headerTemplate"></ng-content>
    </tr>
  </thead>
  <tbody>
  <ng-container *ngFor="let item of items; let id = index">
    <tr>
      <ng-content *ngTemplateOutlet="firstTemplate; context: { $implicit: item, index: id }"></ng-content>
    </tr>
  </ng-container>
  </tbody>
</table>
